// libs
import { Record, List } from "immutable";
import * as utils from "../utils";


const BaseRecord = Record({
  name: null, // string
  subName: null, // string
  description: null, // string
  price: 0,
  details: List(), // List<string>
  image: null
});

export default class MenuItem extends BaseRecord {
  init(data) {
    // console.log(data.details);
    let details = List();

    if (data.details) {
      details = data.details.map(data => data.item);
    }

    let price = utils.formatNumToSeparatedString(data.price) + " 円";

    if (data.wave && data.wave.length > 0) {
      price = `${price} 〜`;
    }
    if (data.reserve && data.reserve.length > 0) {
      price = `${price}（要予約）`;
    }

    return this.withMutations(s =>
      s.set("name", data.name)
       .set("subName", data.sub_name && data.sub_name.trim().length > 0 ? data.sub_name : null)
       .set("description", data.description && data.description.trim().length > 0 ? data.description.replace("\n", "<br>") : null)
       .set("price", price)
       .set("details", details)
       .set("image", data.image && data.image.length > 0 ? data.image : null)
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/MenuItem.js